import { Switch, Route, useLocation } from "wouter";
import { AdminLayout } from "@/components/layout/admin-layout";
import AdminDashboard from "@/pages/admin/dashboard";
import AdminSettings from "@/pages/admin/settings";
import EmailTemplatesPage from "@/pages/admin/email-templates";
import ClientsPage from "@/pages/admin/clients";
import ClientDetailPage from "@/pages/admin/client-detail";
import ContractsPage from "@/pages/admin/contracts";
import ContractDetailPage from "@/pages/admin/contract-detail";
import BudgetsPage from "@/pages/admin/budgets";
import BudgetDetailPage from "@/pages/admin/budget-detail";
import ServiceTypesPage from "@/pages/admin/service-types";
import ServiceItemsPage from "@/pages/admin/service-items";
import ProductsPage from "@/pages/admin/products";
import ServicesPage from "@/pages/admin/services";
import RenewalsPage from "@/pages/admin/renewals";
import EmailLogsPage from "@/pages/admin/email-logs";
import InvoicesPage from "@/pages/admin/invoices";
import InvoiceDetailPage from "@/pages/admin/invoice-detail";
import ReportingPage from "@/pages/admin/reporting";
import TicketsPage from "@/pages/admin/tickets";
// ticket-detail absorbed into tickets.tsx split view
import ChannelsPage from "@/pages/admin/channels";
import CannedRepliesPage from "@/pages/admin/canned-replies";
import WorkRequestsPage from "@/pages/admin/work-requests";
import WorkRequestDetailPage from "@/pages/admin/work-request-detail";
import KnowledgebasePage from "@/pages/admin/knowledgebase";
import AiScopingLogsPage from "@/pages/admin/ai-scoping-logs";
import UsersPage from "@/pages/admin/users";
import RoleDetailPage from "@/pages/admin/role-detail";
import AuditLogPage from "@/pages/admin/audit-log";
import ProjectsPage from "@/pages/admin/projects";
import ProjectDetailPage from "@/pages/admin/project-detail";
import BookingsPage from "@/pages/admin/bookings";
import CapacityPage from "@/pages/admin/capacity";
import AdminIntegrationsPage from "@/pages/admin/integrations";
import AdminAccountPage from "@/pages/admin/account";
import SiteAuditsPage from "@/pages/admin/site-audits";
import SiteAuditDetailPage from "@/pages/admin/site-audit-detail";
import AdminFilesPage from "@/pages/admin/files";
import NotFound from "@/pages/not-found";

export function AdminRoutes() {
  return (
    <Switch>
      <Route path="/">
        <AdminLayout title="Dashboard">
          <AdminDashboard />
        </AdminLayout>
      </Route>

      {/* Billing */}
      <Route path="/clients">
        <AdminLayout title="Clients">
          <ClientsPage />
        </AdminLayout>
      </Route>
      <Route path="/clients/:id">
        <AdminLayout title="Client Detail">
          <ClientDetailPage />
        </AdminLayout>
      </Route>
      <Route path="/contracts">
        <AdminLayout title="Contracts">
          <ContractsPage />
        </AdminLayout>
      </Route>
      <Route path="/contracts/:id">
        <AdminLayout title="Contract Detail">
          <ContractDetailPage />
        </AdminLayout>
      </Route>
      <Route path="/budgets">
        <AdminLayout title="Budgets">
          <BudgetsPage />
        </AdminLayout>
      </Route>
      <Route path="/budgets/:id">
        <AdminLayout title="Budget Detail">
          <BudgetDetailPage />
        </AdminLayout>
      </Route>
      <Route path="/service-types">
        <AdminLayout title="Service Types">
          <ServiceTypesPage />
        </AdminLayout>
      </Route>
      <Route path="/service-items">
        <AdminLayout title="Service Items">
          <ServiceItemsPage />
        </AdminLayout>
      </Route>
      <Route path="/services">
        <AdminLayout title="Services">
          <ServicesPage />
        </AdminLayout>
      </Route>
      <Route path="/products">
        <AdminLayout title="Products">
          <ProductsPage />
        </AdminLayout>
      </Route>
      <Route path="/renewals">
        <AdminLayout title="Renewals">
          <RenewalsPage />
        </AdminLayout>
      </Route>
      <Route path="/email-logs">
        <AdminLayout title="Email Logs">
          <EmailLogsPage />
        </AdminLayout>
      </Route>
      <Route path="/invoices">
        <AdminLayout title="Invoices">
          <InvoicesPage />
        </AdminLayout>
      </Route>
      <Route path="/invoices/:id">
        <AdminLayout title="Invoice Detail">
          <InvoiceDetailPage />
        </AdminLayout>
      </Route>
      <Route path="/reporting">
        <AdminLayout title="Reporting">
          <ReportingPage />
        </AdminLayout>
      </Route>

      {/* Support — split-pane view handles both list and detail */}
      <Route path="/tickets/:id?">
        <AdminLayout title="Tickets" noPadding>
          <TicketsPage />
        </AdminLayout>
      </Route>
      <Route path="/channels">
        <AdminLayout title="Channels">
          <ChannelsPage />
        </AdminLayout>
      </Route>
      <Route path="/canned-replies">
        <AdminLayout title="Canned Replies">
          <CannedRepliesPage />
        </AdminLayout>
      </Route>

      {/* Intake */}
      <Route path="/work-requests">
        <AdminLayout title="Work Requests">
          <WorkRequestsPage />
        </AdminLayout>
      </Route>
      <Route path="/work-requests/:id">
        <AdminLayout title="Work Request Detail">
          <WorkRequestDetailPage />
        </AdminLayout>
      </Route>
      <Route path="/knowledgebase">
        <AdminLayout title="Knowledgebase">
          <KnowledgebasePage />
        </AdminLayout>
      </Route>
      <Route path="/ai-scoping-logs">
        <AdminLayout title="AI Scoping Logs">
          <AiScopingLogsPage />
        </AdminLayout>
      </Route>

      {/* Delivery */}
      <Route path="/projects">
        <AdminLayout title="Projects">
          <ProjectsPage />
        </AdminLayout>
      </Route>
      <Route path="/projects/:id">
        <AdminLayout title="Project Detail">
          <ProjectDetailPage />
        </AdminLayout>
      </Route>
      <Route path="/bookings">
        <AdminLayout title="Bookings">
          <BookingsPage />
        </AdminLayout>
      </Route>
      <Route path="/capacity">
        <AdminLayout title="Capacity">
          <CapacityPage />
        </AdminLayout>
      </Route>

      <Route path="/integrations">
        <AdminLayout title="Integrations">
          <AdminIntegrationsPage />
        </AdminLayout>
      </Route>

      {/* Prospecting */}
      <Route path="/site-audits">
        <AdminLayout title="Site Audits">
          <SiteAuditsPage />
        </AdminLayout>
      </Route>
      <Route path="/site-audits/:id">
        <AdminLayout title="Audit Detail">
          <SiteAuditDetailPage />
        </AdminLayout>
      </Route>

      <Route path="/files">
        <AdminLayout title="Client Files">
          <AdminFilesPage />
        </AdminLayout>
      </Route>

      {/* Administration */}
      <Route path="/account">
        <AdminLayout title="Account Settings">
          <AdminAccountPage />
        </AdminLayout>
      </Route>
      <Route path="/settings">
        <AdminLayout title="Settings">
          <AdminSettings />
        </AdminLayout>
      </Route>
      <Route path="/email-templates">
        <AdminLayout title="Email Templates">
          <EmailTemplatesPage />
        </AdminLayout>
      </Route>
      <Route path="/users/roles/new">
        <AdminLayout title="Create Role">
          <RoleDetailPage />
        </AdminLayout>
      </Route>
      <Route path="/users/roles/:id">
        <AdminLayout title="Role Detail">
          <RoleDetailPage />
        </AdminLayout>
      </Route>
      <Route path="/users">
        <AdminLayout title="Users">
          <UsersPage />
        </AdminLayout>
      </Route>
      <Route path="/audit-log">
        <AdminLayout title="Audit Log">
          <AuditLogPage />
        </AdminLayout>
      </Route>

      <Route>
        <AdminLayout>
          <NotFound />
        </AdminLayout>
      </Route>
    </Switch>
  );
}
